export const APIBASE = "https://portalapi.pfalzmarkt.de/";
export const ASSETSBASE = "https://portalapi.pfalzmarkt.de/assets/";
export const RELOADORDERSALLMINUTES="10"
export const TURNSTILE_KEY="0x4AAAAAAA9WTQPJ3Nf9vicZ"